/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import createMarkup from '@xanadu/ui-shared/utils/createMarkupHTML';

import styles from './LicenseContainer.module.scss';

const LicenseContainer = ({ licenseText }) => (
  <div className={styles.licensing} dangerouslySetInnerHTML={createMarkup(licenseText)} />
);

LicenseContainer.propTypes = {
  licenseText: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    licenseText: state.getIn(['application', 'licenseText']),
  };
}

export default connect(mapStateToProps, null)(LicenseContainer);
